import { gerarTokenSso } from "../crud/pum.crud";
import { Constants } from "./Constants";
import Swal from "sweetalert2";

const ERROR_MESSAGES = {
  empresa_sem_acesso: {
    icon: "warning",
    title: "Acesso ao PUMP não disponível",
    showSalesLink: true,
  },
  usuario_nao_admin: {
    icon: "error",
    title: "Acesso Restrito",
  },
  usuario_sem_acesso: {
    icon: "warning",
    title: "Sem Permissão",
  },
  default: {
    icon: "error",
    title: "Ops!",
    text:
      "Ocorreu um erro ao tentar acessar o PUMP. Por favor, tente novamente.",
  },
};

const showErrorAlert = (errorType, message) => {
  const config = ERROR_MESSAGES[errorType] || ERROR_MESSAGES.default;

  const alertConfig = {
    icon: config.icon,
    title: config.title,
    text: config.text || message,
    confirmButtonText: "Entendi",
    confirmButtonColor: "#284EEA",
  };

  if (config.showSalesLink) {
    alertConfig.html = `
      <p>${message}</p>
      <p style="margin-top: 16px;">
        <strong>Quer conhecer o PUMP?</strong><br/>
        Acesse nossa página de vendas para saber mais.
      </p>
    `;
    alertConfig.confirmButtonText = "Conhecer o PUMP";
    alertConfig.showCancelButton = true;
    alertConfig.cancelButtonText = "Fechar";
    delete alertConfig.text;

    Swal.fire(alertConfig).then((result) => {
      if (!result.isConfirmed) return;
      window.open("https://evento.lincohnagner.com.br/pv-shelby/", "_blank");
    });
    return;
  }

  Swal.fire(alertConfig);
};

export const openPump = () => {
  const newWindow = window.open("about:blank", "_blank");

  gerarTokenSso()
    .then((res) => {
      newWindow.location.href = `${Constants.pumpFrontendUrl}/auth/sso?token=${res.data.token}`;
    })
    .catch((err) => {
      newWindow.close();

      const errorType = err.response?.data?.error;
      const errorMessage = err.response?.data?.message;

      showErrorAlert(errorType, errorMessage);
    });
};
